module.exports = __webpack_public_path__ + "static/img/nhis-cs.f3cbce3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/nhis-cs.jpg
// module id = 1kdN
// module chunks = 0